import { render, staticRenderFns } from "./chat-list-msg.vue?vue&type=template&id=52e97d74"
import script from "./chat-list-msg.vue?vue&type=script&lang=js"
export * from "./chat-list-msg.vue?vue&type=script&lang=js"
import style0 from "./chat-list-msg.vue?vue&type=style&index=0&id=52e97d74&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports